import React, { SetStateAction } from "react";

interface ICalculator {
  value: string;
  setValue: React.Dispatch<SetStateAction<string>>;
  setArr: React.Dispatch<SetStateAction<string[]>>;
}

const Calculator = ({ value, setValue, setArr }: ICalculator) => {
  const handleClick = (e: any) => {
    let decimal = false;
    if (
      (Number(e.target.innerHTML) >= 0 && Number(e.target.innerHTML) <= 9) ||
      (e.target.innerHTML === "." && !decimal)
    ) {
      setValue((prev: string) =>
        prev !== "0"
          ? (prev += e.target.innerHTML)
          : (prev = e.target.innerHTML)
      );
    } else if (
      e.target.innerHTML === "+" ||
      e.target.innerHTML === "-" ||
      e.target.innerHTML === "X" ||
      e.target.innerHTML === "÷"
    ) {
      decimal = true;
      setValue((prev: string) => (prev += e.target.innerHTML));
    } else if (e.target.innerHTML === "Back") {
      const newValue: string = value.slice(0, -1);
      setValue(newValue);
    } else if (e.target.innerHTML === "C") {
      setValue("0");
    } else if (e.target.innerHTML === "=" && value !== "0") {
      let queries = [],
        query = "";
      for (let i = 0; i < value.length; i++) {
        if (value[i] === "+") {
          queries.push(query);
          queries.push("+");
          query = "";
        } else if (value[i] === "-") {
          queries.push(query);
          queries.push("-");
          query = "";
        } else if (value[i] === "X") {
          queries.push(query);
          queries.push("X");
          query = "";
        } else if (value[i] === "÷") {
          queries.push(query);
          queries.push("÷");
          query = "";
        } else {
          query += value[i];
        }
      }
      queries.push(query);
      let curr = Number(queries[0]);
      for (let i = 1; i < queries.length; i += 2) {
        if (queries[i] === "+") {
          curr = curr + Number(queries[i + 1]);
        } else if (queries[i] === "-") {
          curr = curr - Number(queries[i + 1]);
        } else if (queries[i] === "X") {
          curr = curr * Number(queries[i + 1]);
        } else if (queries[i] === "÷") {
          curr = curr / Number(queries[i + 1]);
        }
      }
      const history = localStorage.getItem("history");
      if (!history) return;
      const historyArr = JSON.parse(history);
      historyArr.push(value + " = " + curr);
      setArr(historyArr);
      localStorage.setItem("history", JSON.stringify(historyArr));
      setValue("0");
    }
  };

  return (
    <div className="calculator-wrapper" onClick={handleClick}>
      <div className="row">
        <div className="col gray">CE</div>
        <div className="col gray">C</div>
        <div className="col gray">Back</div>
        <div className="col gray">÷</div>
      </div>
      <div className="row">
        <div className="col">7</div>
        <div className="col">8</div>
        <div className="col">9</div>
        <div className="col gray">X</div>
      </div>
      <div className="row">
        <div className="col">4</div>
        <div className="col">5</div>
        <div className="col">6</div>
        <div className="col gray">-</div>
      </div>
      <div className="row">
        <div className="col">1</div>
        <div className="col">2</div>
        <div className="col">3</div>
        <div className="col gray">+</div>
      </div>
      <div className="row">
        <div className="col gray"></div>
        <div className="col">0</div>
        <div className="col gray">.</div>
        <div className="col gray">=</div>
      </div>
    </div>
  );
};

export default Calculator;
